module.exports = __webpack_public_path__ + "img/bg4.a4a1179b.jpg";